import { Component, OnInit, Input, Output, TemplateRef, EventEmitter, HostListener, Injectable } from '@angular/core';
import { IPropertyCard } from '../../shared/models/propertycard';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PropertyManagementService } from '../../shared/providers/property-management.service';
import { IPlaceOfferUserOutput } from '../../shared/models/PlaceOfferUserOutputModel';
import { IPlaceOfferInputModel } from '../../shared/models/PlaceOfferInputModel';
import { IPlaceOfferResultOutputModel } from '../../shared/models/PlaceOfferResultOutputModel';
import { IFileUpload } from '../../shared/models/fileupload';
import { FileUploadService } from '../../shared/providers/fileupload.service';
import { ToastService } from '../../shared/providers/toast.service'


@Component({
    selector: 'be-place-offer',
    templateUrl: './place-offer.component.html',
})

export class PlaceOfferComponent implements OnInit {

    img: string;
    offset: number;
    srcSet = true;
    @Input() modalRef: BsModalRef;
    placeOfferModel = {} as IPlaceOfferUserOutput;
  placeOfferResultOutputModel = {} as IPlaceOfferResultOutputModel;
  fileTypes = '.PDF, .XLSX, .XLS, .DOCX, .DOC, .TXT, .DWG'
    @Input() property: IPropertyCard;
    userGuid: string;
    @Input() placeOfferInputModel: IPlaceOfferInputModel;
    inputFileUpload = {} as IFileUpload;
    fileExtensionType: string = "document";
    fileUploadType: string = "single";
    @Input() showFileUpload: boolean;
    user: any;
    errorMessage: string;
    OfferPriceValid: boolean = true;
    EarnestMoneyDepositValid: boolean = true;
    DueDiligencePeriodValid: boolean = true;
    ClosingPeriodValid: boolean = true;
    @Output() offerPlaced: EventEmitter<any> = new EventEmitter<any>();

    constructor(private modalService: BsModalService, private authService: AuthenticationService, private router: Router, private _propertyManagerService: PropertyManagementService, private _toastService: ToastService, private _fileUploadService: FileUploadService) { }


    clearFiles: number = 0;
    uploadFiles() {
        this._fileUploadService.uploadFiles(this.inputFileUpload, this.selectedFiles).subscribe(response => {
            this.clearFiles++;

        });
    }

    IsinValid(value: any) {

        if (value == undefined || value == '' || value == null) {
            return true;
        }
        if (value.toString().trim().length <= 0) {
            return true;
        }
        if (!value) {
            return true;
        }
        return false;
    }

    ngOnInit() {
        this.setUploadDefaultValues();
        this.user = this.authService.user;

        if (this.user.Guid != undefined) {
            this.placeOfferModel.Name = this.user.FirstName + " " + this.user.LastName;
            this.placeOfferModel.Email = this.user.UserName;
            this.placeOfferModel.Phone = this.user.PhoneNumber;
            this.placeOfferInputModel.UserId = this.user.Id;
            this.placeOfferInputModel.Comments = null;
            this.placeOfferInputModel.OfferPrice = null;
            this.placeOfferInputModel.DueDiligencePeriod = null;
            this.placeOfferInputModel.EarnestMoneyDeposit = null;
            this.placeOfferInputModel.ClosingPeriod = null;
        }
    }

    selectedFiles: string[] = [];
    selectedFilesListEmitter(selectedFilesListEmitter: string[]) {
        this.errorMessage = null;
        this.selectedFiles = selectedFilesListEmitter;
    }
    setUploadDefaultValues() {
        this.inputFileUpload.fileCategoryId = 408;
        this.inputFileUpload.id = 0;
        this.inputFileUpload.objectId = 0;
        this.inputFileUpload.objectTypeId = 303;
        this.inputFileUpload.documentName = "User Document";
        this.inputFileUpload.type = "Documents";
    }

    savePlaceOffer(type) {
        
        let valid: boolean = true;
        // type === 1 place offer else inquiry
        if (type === 1) {
            if (this.IsinValid(this.placeOfferInputModel.OfferPrice)) {
                this.OfferPriceValid = false;
                valid = false;
            }
            else {
                this.OfferPriceValid = true;
            }
            if (this.IsinValid(this.placeOfferInputModel.DueDiligencePeriod)) {
                this.DueDiligencePeriodValid = false;
                valid = false;
            }
            else {
                this.DueDiligencePeriodValid = true;
            }
            if (this.IsinValid(this.placeOfferInputModel.ClosingPeriod)) {
                this.ClosingPeriodValid = false;
                valid = false;
            }
            else {
                this.ClosingPeriodValid = true;
            }
            if (this.IsinValid(this.placeOfferInputModel.EarnestMoneyDeposit)) {
                this.EarnestMoneyDepositValid = false;
                valid = false;
            }
            else {
                this.EarnestMoneyDepositValid = true;
            }
        }
        if (valid) {
            if (type === 1) {
                if (this.showFileUpload == true) {
                    this.errorMessage = null;
                    if (this.selectedFiles.length > 0) {
                        this._propertyManagerService.updateUser(this.placeOfferInputModel).subscribe(response => {
                            this.placeOfferResultOutputModel = response;
                            if (this.placeOfferResultOutputModel.Success == true) {
                                if (this.selectedFiles.length > 0) {
                                    this.inputFileUpload.objectId = this.placeOfferResultOutputModel.Id;
                                    this.inputFileUpload.id = this.placeOfferResultOutputModel.Id;
                                    this.uploadFiles();
                                    this._toastService.addToast({
                                        title: 'Message', msg: 'You have placed the offer successfully!', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
                                    this.modalRef.hide();
                                    this.offerPlaced.emit(1);
                                }
                                else {
                                }
                            }
                            else {
                                this._toastService.addToast({ title: 'Place offer failed', msg: this.placeOfferResultOutputModel.ReturnMsg, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
                            }
                        },
                            err => {
                                console.log(err);
                                this._toastService.addToast({ title: 'Place offer failed', msg: "An error Occurred. Please contact Administrator.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })

                            }
                        );
                    }
                    else {
                        this.errorMessage = "Please upload a document";
                    }
                }
            }
            else {
                this._propertyManagerService.saveInquiry(this.placeOfferInputModel).subscribe(response => {
                    this.placeOfferResultOutputModel = response;
                    if (this.placeOfferResultOutputModel.Success == true) {
                        this._toastService.addToast({ title: 'Message', msg: 'Inquiry submitted successfully!', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
                        this.modalRef.hide();
                    }
                    else {
                        this._toastService.addToast({ title: 'Inquiry not submitted', msg: this.placeOfferResultOutputModel.ReturnMsg, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
                    }
                },
                    err => {
                        console.log(err);
                        this._toastService.addToast({ title: 'Inquiry not submitted', msg: "An error Occurred. Please contact Administrator.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
                        
                    });
            }
        }
    }
}
